export default "__VITE_ASSET__DfN96fHe__"